/*eslint-disable*/

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './HeaderSaveSearch.module.css';
// import image from '../../assets/images/house.jpg';

// import { BaseURL } from '../../config/apiUrl';
// import { Get } from '../../Axios/AxiosFunctions';
// import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { AiFillHeart } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { Get } from '../../Axios/AxiosFunctions';
import {
  BaseURL,
  capitalizeFirstLetter,
  discardUndefinedOrNullValues,
  formRegEx,
  formRegExReplacer
} from '../../config/apiUrl';
import NoData from '../NoData/NoData';
import { commercialLangObj, residentialLangObj } from '../../config/DummyData';
import { m2ToFt2 } from '../../utils/helpers';
// import { MdNotifications } from "react-icons/md";

const Notifications = ({ item }) => {
  const navigate = useNavigate();
  const { areaUnit } = useSelector((state) => state.converterReducer);
  const saveSearchParams = discardUndefinedOrNullValues({
    ...item?.data,
    ...(item?.data?.minArea
      ? {
          minArea:
            areaUnit == 'm²'
              ? item?.data?.minArea
              : parseInt(
                  m2ToFt2({
                    area: item?.data?.minArea,
                    areaUnit: 'ft²',
                    unit: false
                  })
                )
        }
      : {}),
    ...(item?.data?.maxArea
      ? {
          maxArea:
            areaUnit == 'm²'
              ? item?.data?.maxArea
              : parseInt(
                  m2ToFt2({
                    area: item?.data?.maxArea,
                    areaUnit: 'ft²',
                    unit: false
                  })
                )
        }
      : {}),
    province: item?.province || null,
    neighborhood: item?.neighborhood || null,
    town: item?.town || null,
    entity: item?.entity || null,
    ...(item?.propertyClassification
      ? {
          propertyClassification:
            item?.propertyClassification == 'residential' ? residentialLangObj : commercialLangObj
        }
      : {}),
    ...(item?.interiorAmenities
      ? {
          interiorAmenities: item?.interiorAmenities
        }
      : {}),
    ...(item?.exteriorAmenities
      ? {
          exteriorAmenities: item?.exteriorAmenities
        }
      : {}),
    ...(item?.projectStatus
      ? {
          projectStatus: item?.projectStatus
        }
      : {}),
    ...(item?.unitType
      ? {
          unitType: item?.unitType
        }
      : {})
  });
  const renderFieldTitles = discardUndefinedOrNullValues({
    type: item?.type,
    province: item?.province?.name?.en,
    [item?.type]: item?.entity?.title?.en,
    town: item?.town?.name?.en,
    neighborhood: item?.neighborhood?.name?.en,
    address: item?.address,
    maxPrice: item?.data?.maxPrice,
    minPrice: item?.data?.minPrice,
    noOfRooms: item?.data?.noOfRooms?.en,
    noOfBathrooms: item?.data?.noOfBathrooms,
    propertyPurpose: item?.data?.propertyPurpose?.en,
    parkingSpace: item?.data?.parkingSpace?.en,
    floorLevel: item?.data?.floorLevel?.en,
    furniture: item?.data?.furniture?.en,
    ...(item?.exteriorAmenities?.length > 0 && {
      exteriorAmenities: item?.exteriorAmenities?.map((a) => a?.title?.en).join(', ')
    }),
    ...(item?.interiorAmenities?.length > 0 && {
      interiorAmenities: item?.interiorAmenities?.map((a) => a?.title?.en).join(', ')
    })
  });
  return (
    <div
      className={[classes.HeaderNotificationInnerDiv]}
      onClick={() => {
        navigate(item.pathName, {
          state: saveSearchParams
        });
      }}>
      <p className="maxLine1">{`Title: ${item?.title}`}</p>
      <p className="maxLine1">
        {Object.entries(renderFieldTitles)
          ?.slice(0, 4)
          ?.map(
            (a) => `${capitalizeFirstLetter(a[0]?.replace(formRegEx, formRegExReplacer))}: ${a[1]}`
          )
          ?.join(', ')}
      </p>
      <div className={[classes.contentDiv]}>
        <div className={classes.time}>
          <p className="">{moment(item?.createdAt).format('Do/MM/YYYY')}</p>
        </div>
      </div>
    </div>
  );
};

const HeaderSaveSearch = ({ t }) => {
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state?.authReducer?.accessToken);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  // fetchNotifications
  const fetchNotifications = async () => {
    const url = BaseURL('savedSearch?page=1&limit=5&type=all');
    setLoading(true);
    let response = await Get(url, accessToken);
    setLoading(false);

    if (response !== undefined) {
      setData(response?.data?.data);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className={[classes.HeaderNotification]}>
      <div className={[classes.notificationHeader]}>
        <AiFillHeart size={25} />
        <h6>{t('webHeader.saveSearchPopup.title')}</h6>
      </div>
      <div className={classes.notificationSkeleton}>
        {loading ? (
          Array(4)
            .fill(0)
            ?.map((index) => (
              <Skeleton key={index} height={'80px'} width={'100%'} variant={'rectangular'} />
            ))
        ) : data?.length == 0 ? (
          <NoData text={t('webHeader.saveSearchPopup.noData')} className={classes.noData} />
        ) : (
          data?.slice(Math.max(data?.length - 5, 0))?.map((item, i) => {
            return (
              <div className={[classes.mb16]} key={i}>
                <Notifications item={item} />
              </div>
            );
          })
        )}
      </div>
      <p
        className={['p18', classes.viewAll].join(' ')}
        onClick={() => {
          navigate('/saved-searches');
        }}>
        {t('webHeader.saveSearchPopup.seeAll')}
      </p>
    </div>
  );
};
export default HeaderSaveSearch;

const saveSearchData = [
  {
    description: 'Full floor for sale ',
    postedBy: 'Anas',
    createdAt: moment()
  },
  {
    description: 'Full floor for sale ',
    postedBy: 'Anas',
    createdAt: moment()
  },
  {
    description: 'Full floor for sale ',
    postedBy: 'Anas',
    createdAt: moment()
  },
  {
    description: 'Full floor for sale ',
    postedBy: 'Anas',
    createdAt: moment()
  },
  {
    description: 'Full floor for sale ',
    postedBy: 'Anas',
    createdAt: moment()
  }
];
